import React, { useState } from "react";
import styles from "../FinalSalePDP/FinalSalePDP.module.scss";
import useMediaQuery from "@/helpers/hooks/useMediaQuery";

const FinalSaleMessage = (props) => {
  const [isFocused, setIsFocused] = useState(false);
  const isTablet = useMediaQuery("(min-width: 601px) and (max-width: 1024px)");
  const isMobile = useMediaQuery("(max-width: 600px)");
  const message = isMobile && props?.mobileMessage?.bannerText ? props?.mobileMessage : 
                  isTablet && props?.tabletMessage?.bannerText ? props?.tabletMessage : 
                  props?.desktopMessage; 

  return (
    message?.bannerText  && <div className={`${styles.finalSaleBanner} ${isFocused ? styles.focused : ""}`} style={{backgroundColor: props.backgroundColor || "#d6c5b9", color: props.fontColor || "#2f2f30"}}>
        {message?.url ? 
        (<a tabIndex={0} href={message.url} rel="noopener noreferrer" className={styles.promoLink} onFocus={() => setIsFocused(true)} onBlur={() => setIsFocused(false)}>
          <p className={`text-sm ga-pdp-final-sale`} ga4data={`${props.gaTrackingName}`}>{message?.bannerText}</p>
        </a>) : 
        <p className={`text-sm ga-pdp-final-sale`} ga4data={`${props.gaTrackingName}`}>{message?.bannerText}</p>}
    </div>
  );
};

export default FinalSaleMessage;